import React, { useCallback } from 'react';

import LinkButton from 'components/uiLibrary/LinkButton';
import Typography from 'components/uiLibrary/Typography';

import { COMPONENTS } from 'components/Globals/Analytics/constants';

import ImpressionTracker from 'utils/components/impressionTracker';
import useNavigate from 'utils/hooks/useNavigate';
import usePageContext from 'utils/hooks/usePageContext';

import { ENTITY_TYPES } from 'operabase-router/constants';

import Actions from '../Actions';
import Entirety from '../Entirety';
import Poster from '../MediaList/Poster';
import Titles from '../Titles';

import classes from './CondensedView.module.scss';

const CondensedView = ({
  data,
  producerNames,
  handlePerformanceClick,
  conductor,
  director,
  trackingData,
  entity,
  entityType,
}) => {
  const navigate = useNavigate();
  const { permissions } = usePageContext();

  const primaryCrewLinkProps = useCallback(
    ({ entity: crewEntity }) =>
      navigate.getLinkProps({
        entityType: ENTITY_TYPES.PROFILE,
        entity: crewEntity,
        pro: permissions?.castingToolPermissions?.hasAccess,
        onlyLinkProps: true,
      }),
    [permissions?.castingToolPermissions?.hasAccess, navigate],
  );

  return (
    <ImpressionTracker
      as="li"
      data={{
        ...trackingData,
        entityId: data.id,
        entityName: data.name,
        entityType: ENTITY_TYPES.PRODUCTION,
      }}
      className={classes.slugItem}
    >
      <article onClick={handlePerformanceClick}>
        <div className={classes.condensedView}>
          <div className={classes.condensedView__left}>
            <Poster production={data} styles={{ poster: classes.poster }} width={45} height={64} />
          </div>
          <div className={classes.condensedView__right}>
            <div className={classes.condensedView__right_dateActions}>
              <Entirety production={data} isCondensedView />
              <Actions data={data} entity={entity} entityType={entityType} trackingData={trackingData} isTextButton />
            </div>
            <Titles data={data} styles={{ prodTitle: classes.prodTitle }} />
            <Typography>{producerNames}</Typography>
            {(conductor?.name || director?.name) && (
              <div className={classes.condensedView__right_cdBlock}>
                {director?.name && (
                  <LinkButton
                    variant="text"
                    size="small"
                    isLink
                    styles={{ root: classes.director }}
                    {...primaryCrewLinkProps({ entity: director })}
                    trackingData={{
                      ...trackingData,
                      component: COMPONENTS.CONDUCTOR_DIRECTOR,
                    }}
                  >
                    D: {director?.name}
                  </LinkButton>
                )}
                {conductor?.name && (
                  <LinkButton
                    variant="text"
                    size="small"
                    isLink
                    styles={{ root: classes.conductor }}
                    {...primaryCrewLinkProps({ entity: conductor })}
                    trackingData={{
                      ...trackingData,
                      component: COMPONENTS.CONDUCTOR_DIRECTOR,
                    }}
                  >
                    C: {conductor?.name}
                  </LinkButton>
                )}
              </div>
            )}
          </div>
        </div>
      </article>
    </ImpressionTracker>
  );
};

export default CondensedView;
